// ``wo`` 可能是外部联系人，也可能是新版加密员工 userid。缺少明确参与人
// 类型时不能仅凭此前缀判定为客户。
const UNAMBIGUOUS_EXTERNAL_USERID_PREFIXES = ['wm', 'wb', 'external_userid_', 'client_'];

export type WeComParticipantType = string | null | undefined;

export const getWeComOpenIdTail = (openid?: string | null) =>
  String(openid || '').split('/').pop() || '';

export const isExternalWeComUserId = (
  openid?: string | null,
  participantType?: WeComParticipantType,
) => {
  if (participantType === 'employee') return false;
  if (participantType === 'external') return true;
  const tail = getWeComOpenIdTail(openid);
  return UNAMBIGUOUS_EXTERNAL_USERID_PREFIXES.some((prefix) => tail.startsWith(prefix));
};

export const isGroupChatOpenId = (openid?: string | null) =>
  Boolean(openid?.startsWith('wr') && !openid.includes('/'));
